<script>
import AdoptionsService from "@/services/adoptions.service";
import ClientsService from "@/services/clients.service";
import MoveBackDialog from "@/components/SinglePostAdoptFirm/MoveBackDialog.vue";

export default {
  name: "PaymentReceived",
  components: { MoveBackDialog },
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: false,
    moveBackDialogVisible: false,
    clients: [],
    selectedClients: [],
    moveLoading: false,
    headers: [
      {
        text: 'Client',
        value: 'trade_name',
        filterable: true
      },
      {
        text: 'EIN',
        value: 'ein',
        filterable: true
      },
      {
        text: 'Legal Name',
        value: 'legal_name',
        filterable: true
      },
      {
        text: 'Date',
        value: 'status_last_changed'
      }
    ],
    selectedQuarter: 1,
    status: 5,
    search: '',
  }),
  methods: {
    async getData() {
      this.loading = true

      try {
        this.clients = await AdoptionsService.getAdoptionsQuarter(this.entityId, this.selectedQuarter, this.status)
      } finally {
        this.loading = false
      }
    },
    handleRowClick(item) {
      this.$router.push(`/clients/${item.client_id}/admin`)
    },
    // async moveToFeesReceived() {
    //   const payload = {
    //     status: 6
    //   }
    //   this.moveLoading = true;
    //
    //   for (let i = 0; i < this.selectedClients.length; i++) {
    //     let client = this.selectedClients[i]
    //     await ClientsService.patchAdoptionQuarters(client.quarter_id, payload)
    //   }
    //   this.selectedClients = []
    //   this.moveLoading = false
    //   await this.getData()
    // }
  },
  watch: {
    selectedQuarter() {
      this.getData()
    }
  },
  mounted() {
    this.getData()
  }
};
</script>

<template>
  <div>
    <MoveBackDialog
      v-if="moveBackDialogVisible"
      @update:visible="event => moveBackDialogVisible = event"
      @success="getData"
      :visible="moveBackDialogVisible"
      :status="19"
      :statusName="`IRS Released Payment`"
      :clients="selectedClients"
    />
    <v-row>
      <v-col cols="12" md="10">
        <v-card>
          <v-card-title style="width: 100%">
            <v-row align="center">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-radio-group v-model="selectedQuarter" row >
                  <v-radio :value="4" label="Q4" />
                  <v-spacer />
                  <v-radio :value="1" label="Q1"/>
                  <v-spacer />
                  <v-radio :value="2" label="Q2"/>
                  <v-spacer />
                  <v-radio :value="3" label="Q3"/>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn block color="primary" :disabled="!selectedClients.length || selectedClients.length > 1" @click="moveBackDialogVisible = true">
                  Move Back
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="clients"
              @click:row="handleRowClick"
              :loading="loading"
              :search="search"
              show-select
              v-model="selectedClients"
              disable-pagination
              item-key="adoption_id"
              hide-default-footer
            >
              <template #item.status_last_changed="{ item }">
                {{ new Date(item.status_last_changed).toLocaleDateString() }}
              </template>
            </v-data-table>
          </v-card-text>
<!--          <v-card-actions>-->
<!--            <v-btn @click="moveToFeesReceived" :loading="moveLoading" :disabled="!selectedClients.length" color="primary">Move to Fees Received</v-btn>-->
<!--          </v-card-actions>-->
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>